import type { WheelEvent } from 'react';

export const preventMouseScrollForNumericFieldHandler = (event: WheelEvent<HTMLInputElement>) => {
	if (event?.currentTarget?.type === 'number') {
		event.currentTarget.blur?.();
	}
};
